import React from 'react'

export default props => (
  <svg viewBox="0 0 16 16" {...props}>
    <path d="M6,16 L10,16 L10,0 L6,0 L6,16 Z M0,16 L4,16 L4,8 L0,8 L0,16 Z M12,5 L12,16 L16,16 L16,5 L12,5 Z" />
  </svg>
)
